(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unakit-stockists"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('unakit-stockist-map')) {
class UnakitStockistMap extends HTMLElement {
 connectedCallback() { Promise.resolve().then(() => this.initialize()); }
 disconnectedCallback() { this.events?.abort(); this.resize?.disconnect(); this.map?.remove(); this.map = null; }
 async initialize() {
  if (this.map || !this.isConnected) return;
  try { await UnakitStockistMap.loadLibrary(); } catch { this.querySelector('.unakit-stockists__map-note').textContent = 'Kartan kunde inte laddas. Använd butikernas länkar för vägbeskrivning.'; return; }
  if (!this.isConnected || this.map) return;
  const root = this, canvas = root.querySelector('.unakit-stockists__map');
  const map = this.map = L.map(canvas, {scrollWheelZoom:false}).setView([57.71,11.98],11);
  this.events = new AbortController(); const signal = this.events.signal;
  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {maxZoom:19, attribution:'&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors'}).addTo(map);
  const entries = [];
  root.querySelectorAll('.store-card').forEach((card,index) => {
   const lat = Number(card.dataset.lat.replace(',','.')), lng = Number(card.dataset.lng.replace(',','.'));
   const button = card.querySelector('button');
   if (!card.dataset.lat.trim() || !card.dataset.lng.trim() || !Number.isFinite(lat) || !Number.isFinite(lng) || Math.abs(lat)>90 || Math.abs(lng)>180) { button.hidden=true; return; }
   const name = card.querySelector('h3').textContent;
   const icon = L.divIcon({className:'unakit-stockists__pin',html:'<span><b>'+(index+1)+'</b></span>',iconSize:[30,36],iconAnchor:[15,36],popupAnchor:[0,-34]});
   const marker = L.marker([lat,lng],{icon,title:name,alt:'Kartnål '+(index+1)+': '+name}).addTo(map);
   const popup = document.createElement('div'), title = document.createElement('strong'), address = document.createElement('p');
   title.textContent=name;address.textContent=card.querySelector('p').textContent;popup.append(title,address,card.querySelector('a').cloneNode(true));marker.bindPopup(popup);
   button.addEventListener('click',()=>{map.setView([lat,lng],16);marker.openPopup();canvas.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});root.querySelectorAll('[data-map-view]').forEach(b=>b.setAttribute('aria-pressed','false'));},{signal});
   entries.push({lat,lng,marker});
  });
  const showView = view => {
   let points=entries.filter(p=>view==='all'||(view==='sweden'?p.lat>55:p.lat<55));if(!points.length)points=entries;
   if(points.length){map.closePopup();map.fitBounds(L.latLngBounds(points.map(p=>[p.lat,p.lng])),{padding:[34,34],maxZoom:14});}
   root.querySelectorAll('[data-map-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mapView===view)));
  };
  root.querySelectorAll('[data-map-view]').forEach(button=>button.addEventListener('click',()=>showView(button.dataset.mapView),{signal}));
  showView('sweden');this.resize=new ResizeObserver(()=>map.invalidateSize());this.resize.observe(canvas);
 }
 static loadLibrary() {
  if(window.L)return Promise.resolve();if(this.loader)return this.loader;
  this.loader=new Promise((resolve,reject)=>{
   let css=document.querySelector('link[data-unakit-leaflet]');if(!css){css=document.createElement('link');css.rel='stylesheet';css.href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';css.integrity='sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';css.crossOrigin='';css.dataset.unakitLeaflet='true';document.head.appendChild(css);}
   let loader=document.querySelector('script[data-unakit-leaflet]');if(!loader){loader=document.createElement('script');loader.src='https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';loader.integrity='sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';loader.crossOrigin='';loader.dataset.unakitLeaflet='true';document.head.appendChild(loader);}
   loader.addEventListener('load',resolve,{once:true});loader.addEventListener('error',reject,{once:true});
  });return this.loader;
 }
}
customElements.define('unakit-stockist-map',UnakitStockistMap);
}


  } catch(e) { console.error(e); }
})();
})();
